var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner'),_c('ServiceContainer'),_c('CoreAdvantages'),_c('CaseModule'),_c('HomeCustomer'),_c('HomeContact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }